import { useCallback, useEffect, useMemo, useRef } from "react";
import axios from "axios";

// Abort old requests AND fence late resolutions from adapters ignoring abort.
export const useLatestRequest = () => {
  const controller = useRef(null), generation = useRef(0);
  const cancel = useCallback(() => { generation.current++; controller.current?.abort(); }, []);
  useEffect(() => cancel, [cancel]);
  const run = useCallback(async (request, success, failure, finish) => {
    cancel(); const current = generation.current;
    controller.current = new AbortController();
    try {
      const value = await request(controller.current.signal);
      if (current === generation.current) success(value);
    } catch (err) {
      if (current === generation.current && !axios.isCancel(err)) failure?.(err);
    } finally { if (current === generation.current) finish?.(); }
  }, [cancel]);
  return useMemo(() => ({ run, cancel }), [run, cancel]);
};